__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "cbs-merchant";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("antd", "5.5.0", function() { return Promise.all([__webpack_require__.e(6831), __webpack_require__.e(618), __webpack_require__.e(4008), __webpack_require__.e(8673), __webpack_require__.e(6097), __webpack_require__.e(1002), __webpack_require__.e(9781), __webpack_require__.e(7780), __webpack_require__.e(3441), __webpack_require__.e(5694), __webpack_require__.e(3109), __webpack_require__.e(9608), __webpack_require__.e(6969), __webpack_require__.e(3247)]).then(function() { return function() { return __webpack_require__(7780); }; }); });
			register("dayjs", "1.11.10", function() { return __webpack_require__.e(5726).then(function() { return function() { return __webpack_require__(5726); }; }); });
			register("dayjs", "1.11.8", function() { return __webpack_require__.e(2053).then(function() { return function() { return __webpack_require__(52053); }; }); });
			register("jotai", "2.0.3", function() { return Promise.all([__webpack_require__.e(7794), __webpack_require__.e(4929)]).then(function() { return function() { return __webpack_require__(64929); }; }); });
			register("react-dom", "18.1.0", function() { return Promise.all([__webpack_require__.e(9103), __webpack_require__.e(9256)]).then(function() { return function() { return __webpack_require__(19103); }; }); });
			register("react-router-dom", "6.3.0", function() { return Promise.all([__webpack_require__.e(8280), __webpack_require__.e(3138), __webpack_require__.e(7243)]).then(function() { return function() { return __webpack_require__(23138); }; }); });
			register("react", "18.1.0", function() { return __webpack_require__.e(3236).then(function() { return function() { return __webpack_require__(93236); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};